import { useCallback, useEffect, useState } from "react";
import { Box } from "@mui/material";

import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";
import Text from "$components/Text";
import { ReceptionReference } from "$types/ReceptionReference";
import { Popin } from "$components/Popin/Popin";
import JTooltip from "$components/JTooltip/JTooltip";
import { Reception } from "$types";
import useReception from "$hooks/useReception";
import ReferencingForm from "$containers/Receptions/Referencing/ReferencingForm";
import { QTY_WIDTH } from "./JReceptionTree";
import BlueTextButton from "./BlueTextButton";
import { ReceptionService } from "$services";

type Props = {
  disabledMessage?: string;
  onEdit?: () => Promise<void> | void;
  reception: Reception;
  receptionReference: ReceptionReference;
};
function ReceptionReferenceLabel({
  disabledMessage,
  onEdit,
  reception,
  receptionReference,
}: Props) {
  const classes = useStyles();
  const { productReference: reference, suborderReferences } =
    receptionReference;
  const {
    referencingOpen,
    toggleReferencingPopin,
    focusedReceptionReferenceId,
  } = useReception();
  const [shouldRefreshAfterClose, setShouldRefreshAfterClose] = useState(false);
  const referenceFocusKey = receptionReference.id;
  const isCurrentPopin = focusedReceptionReferenceId === referenceFocusKey;

  const handleOnSubmit = useCallback(async (data: any) => {
    await ReceptionService.updateReceptionItem(data.id, data);
    setShouldRefreshAfterClose(true);
  }, []);

  useEffect(() => {
    if (!referencingOpen && shouldRefreshAfterClose) {
      setShouldRefreshAfterClose(false);
      if (onEdit) {
        onEdit();
      }
    }
  }, [referencingOpen, shouldRefreshAfterClose, onEdit]);

  return (
    <>
      <Box display="flex" alignItems="center">
        <JTooltip title={disabledMessage}>
          <Text>
            <b>{reference}</b> - ({suborderReferences.join(" - ")})
          </Text>
        </JTooltip>
        <Box flex={1} textAlign="right">
          <BlueTextButton
            onClick={() => toggleReferencingPopin(true, referenceFocusKey)}
          >
            Ref. à la réception
          </BlueTextButton>
        </Box>
        <div className={classes.emptyRightBlock} />
      </Box>
      <Popin openPopin={referencingOpen} toggleDrawer={toggleReferencingPopin}>
        {isCurrentPopin && (
          <>
            <Text type="h2">Référencement</Text>
            <ReferencingForm
              focusedReceptionReferenceId={focusedReceptionReferenceId}
              isReadOnly={false}
              isSavingReception={false}
              onSubmit={handleOnSubmit}
              reception={reception}
              togglePopin={toggleReferencingPopin}
            />
          </>
        )}
      </Popin>
    </>
  );
}

export default ReceptionReferenceLabel;

const useStyles = createUseStyles(() => ({
  emptyRightBlock: {
    width: `calc(${QTY_WIDTH} - ${theme.spacing(1)}px)`, // align with qty / unit below
  },
}));
